/// <reference types="../index.d.ts" />

export { Chatbot } from "./components/chatbot/chatbot";
